import { useState, useEffect, useContext } from 'react'
import { AppContext } from './../App'

export function useGet (uri, primary) {
  const { user, loadingCount, setLoadingCount, setNotFound, setPermissionDenied, reloadCounter, error, setError } = useContext(AppContext)
  const [data, setData] = useState(null)
  const [count, setCount] = useState(null)
  const [total, setTotal] = useState(null)
  const [info, setInfo] = useState(null)
  // HTTP status of the latest response for this call, or 0 before one arrives.
  // Set for every status (unlike the global `notFound`, which is only set for
  // `primary` fetches to drive the full-page RadError). Lets a caller such as
  // EntityModal show an in-context state, e.g. 404 -> "no longer available".
  const [status, setStatus] = useState(0)

  useEffect(() => {
    (async () => {
      if (uri) {
        setLoadingCount(count => count + 1)
        setStatus(0)
        const token = await user.getIdToken()
        const response = await fetch(uri, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` }
        })
        setStatus(response.status)
        let text
        let json
        switch (response.status) {
          case 200:
            try {
              json = await response.json()
              setData(json)
            } catch { }
            setCount(response.headers.get('count'))
            setTotal(response.headers.get('total'))
            setInfo(response.headers.get('info'))
            if (primary) {
              setNotFound(false)
              setError(null)
              setPermissionDenied(null)
            }
            break
          case 403:
            text = await response.text()
            setPermissionDenied(text)
            if (primary) {
              setNotFound(false)
              setData(null)
            }
            break
          case 404:
            setData(null)
            if (primary) {
              setNotFound(true)
            }
            break
          case 500:
            console.log(response.statusText)
            setError({ code: response.statusText })
            if (primary) {
              setNotFound(false)
              setPermissionDenied(null)
            }
            break
          default:
        }
        setLoadingCount(count => count - 1)
      } else {
        setError(null)
        setData(null)
        setStatus(0)
      }
    })()
  }, [uri, primary, reloadCounter, setLoadingCount, setNotFound, setPermissionDenied, user, setError])

  return { data, count, total, info, error, isLoading: loadingCount > 0, status }
}
